import axios from "axios";


const creditoService = {
    getCreditoById: async (idCredito: number) => {
        try {
           
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Credito/getCredito/${idCredito}`                
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    getLineaCreditoById: async (idLineaDeCredito: number) => {
        try {           
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/CreditoLineaDeCredito/getLineaCreditoById/${idLineaDeCredito}`                
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    getCreditosParaUsuario: async () => {
        try {           
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Credito/GetCreditosPorAfiliado`              
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    getLineasCreditoParaBenficiario: async () => {
        try {          
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/CreditoLineaDeCredito/GetLineasCreditoParaBeneficiario`                
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    getLineasCreditoParaAfiliado: async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/CreditoLineaDeCredito/GetLineasCreditoParaAfiliado`
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    calcularMaximos: async (idLineaDeCredito: number, cantCuotas: number, idBeneficiario: number, idTipoBeneficio: number) => {
        try {            
            const response = await axios({
                method: "GET",
                url: `${process.env.REACT_APP_API_URL}/api/Credito/calcularMaximos`,                
                params: {
                    idBeneficiario,
                    idTipoBeneficio,
                    idLineaDeCredito,
                    cantCuotas
                }
            });
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    simular: async (datosSimulacion: any) => {
        try {           
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/Credito/simular`,
                datosSimulacion                
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    solicitar: async (formData: any) => {
        try {           
            const config = {
                headers: {                   
                    'Content-Type': 'multipart/form-data'
                }
            }
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/Credito/crear`,
                formData,
                config
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

}

export default creditoService

